import { useUnit } from 'effector-react';
import { changeEvent, publishChangesFx } from '@nx-frontend/shared/store/change-events-store';
import { $portalId, $workspaceId } from '@nx-frontend/shared/store/portal-app';
import { $pageInfo } from '@nx-frontend/shared/store/portal-page';
import { $userId } from '@nx-frontend/shared/store/user';
import { ChangeEvent, ChangeEventWithPartialMeta } from '@nx-frontend/shared/types';

interface ApplyChangeEventsProps {
  events: ChangeEventWithPartialMeta[];
  publish?: boolean;
  squashId?: string;
}

export const useApplyChangeEvents = (): ((props: ApplyChangeEventsProps) => Promise<ChangeEvent[]>) => {
  const [publishChanges, workspaceId, portalId, setChanges, { title, path, pageId }, userId] = useUnit([
    publishChangesFx,
    $workspaceId,
    $portalId,
    changeEvent,
    $pageInfo,
    $userId,
  ]);

  return async ({ events, publish = false, squashId }) => {
    if (userId === 1) {
      throw new Error('Unauthorized users are not permitted to apply changes');
    }

    const meta = {
      userId,
      path,
      pageId,
      updatedAt: Date.now(),
      pageTitle: title ?? path,
    };

    const result = events.map((event) => {
      return setChanges({
        ...event,
        meta: { ...meta, ...(event.meta ?? null) },
        squashId,
      });
    });

    if (publish) {
      await publishChanges({ workspaceId, portalId, history: result });
    }

    return result;
  };
};
